export default __webpack_public_path__ + "static/home_transaction-9ac711b7533594f0a71dd9204f414f9d.png";